import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewIssueModalComponent } from './new-issue-modal.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [NewIssueModalComponent],
  exports : [NewIssueModalComponent]
})
export class NewIssueModalModule { }